import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import Option from './Option'
import { StyledBqSelect } from './styles'
import { deflate, inflate } from './utils'
import _ from 'underscore'

export const NestedSelect = forwardRef(({
  name,
  label,
  selectedLabel,
  value,
  disableClear = true,
  disabled = false,
  placeholder,
  dataTestId = 'nested-select',
  options,
  onSelect,
  onBlur,
  maxTagsVisible = 2,
  defaultOption = ''
}, ref) => {
  return (
    <StyledBqSelect
      ref={ref}
      name={name}
      value={JSON.stringify(value)}
      multiple
      maxTagsVisible={maxTagsVisible}
      disableClear={disableClear}
      disabled={disabled}
      placeholder={placeholder}
      data-testid={`${dataTestId}-${name}`}
      onBqSelect={(event) => {
        if (Array.isArray(event.detail.value)) {
          const state = inflate(value, options)
          const changes = event.detail.value.length > value.length ? _.difference(event.detail.value, value) : _.difference(value, event.detail.value)
          const values = deflate(state, changes.length ? changes : value, options)
          if (defaultOption === '') {
            onSelect(values)
          } else {
            onSelect(inflate(values, options).includes(defaultOption) ? values : [...values, defaultOption])
          }
        }
      }}
      onBqBlur={onBlur}
    >
      {label && <>
        <label className='caption' slot="label">{label}</label>
        <label className='caption' slot="label" data-testid={`${dataTestId}-${label}`}>{selectedLabel}</label>
      </>}
      {options?.map((option) => <Option key={option.value} option={option} value={value} defaultOption={defaultOption} />)}
    </StyledBqSelect>
  )
})

NestedSelect.displayName = 'NestedSelect'

const optionShape = {
  value: PropTypes.string.isRequired
}

optionShape.innerValues = PropTypes.arrayOf(PropTypes.shape(optionShape))

NestedSelect.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  selectedLabel: PropTypes.string,
  value: PropTypes.arrayOf(PropTypes.string).isRequired,
  placeholder: PropTypes.string,
  disableClear: PropTypes.bool,
  disabled: PropTypes.bool,
  dataTestId: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape(optionShape)),
  onSelect: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  maxTagsVisible: PropTypes.number,
  defaultOption: PropTypes.string
}

export default NestedSelect
